import React from "react";
import { UIStyles } from "./styles";


const Loader: React.FC = () => {
  return (
    <div style={styles.container}>
      
      {/* Main Content */}
      <div style={styles.contentContainer}>
        {/* Logo */}
        <img 
          src="/graph_logo.png" 
          alt="Graph Surfer Logo" 
          style={styles.logo}
        />
        
        {/* Progress Bar Container */}
        <div style={styles.progressBarContainer}>
          {/* Progress Fill - Indeterminate animation */}
          <div style={styles.progressFill}>
            {/* Animated Shine Effect */}
            <div style={styles.shineEffect} />
          </div>
        </div>
      </div>
      
      {/* CSS Animations */}
      <style>{`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
        
        @keyframes indeterminateProgress {
          0% { left: -30%; }
          100% { left: 100%; }
        }
      `}</style>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#efeee7', // Neutral background
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '40px',
    width: '100%',
    maxWidth: '400px',
    padding: '20px',
  },
  logo: {
    width: '150px',
    height: 'auto',
    objectFit: 'contain',
  },
  progressBarContainer: {
    width: '100%',
    height: '18px',
    background: 'rgba(37, 34, 36, 0.1)',
    borderRadius: '20px',
    overflow: 'hidden',
    position: 'relative',
    border: '1.5px solid #521616',
    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  progressFill: {
    width: '30%',
    height: '100%',
    background: 'linear-gradient(90deg, #d498ac 0%, #ecd3d5 100%)',
    borderRadius: '20px',
    position: 'relative',
    overflow: 'hidden',
    animation: 'indeterminateProgress 1.5s infinite ease-in-out',
  },
  shineEffect: {
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    animation: 'shine 2s infinite',
  },
};

export default Loader;
